module.exports = __webpack_public_path__ + "static/media/ETF.05e021a9.png";